// extracted by mini-css-extract-plugin
export default {"wrapper":"zu-z","viewport":"Au-z","container":"Bu-z","slide":"Cu-z"};